<script setup>
  defineOptions({
    name: "ComponentCard",
  });

  defineProps({
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
  });
</script>

<template>
  <section class="bg-white shadow-md" :data-test="getTestId('card')">
    <div v-if="title.length > 0">
      <div class="flex items-center space-x-2 px-4 pt-4">
        <h5 class="text-2xl">{{ title }}</h5>

        <div v-if="$slots['info-i-icon']" class="mt-0.5">
          <slot name="info-i-icon" />
        </div>

        <template v-if="$slots['button']">
          <slot name="button" />
        </template>
      </div>

      <h6 class="px-4" v-text="subtitle" />
    </div>

    <div class="p-4">
      <slot />
    </div>

    <div v-if="$slots['actions']" class="flex flex-row-reverse items-center space-x-4 space-x-reverse p-4 print:hidden">
      <slot name="actions" />
    </div>
  </section>
</template>
